import { User, Mail, Phone, Video, CreditCard, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { MEETING_METHODS } from "@/lib/links";
import { GiftCodeField } from "@/components/booking/GiftCodeField";

function PaymentNote({ form, member, price, memberPrice }) {
  if (form.gift) return null;
  const included = member?.included;
  return (
    <div className="sm:col-span-2 rounded-xl border border-slate-800 bg-slate-900/40 p-4 text-sm flex items-start gap-3" data-testid="booking-payment-note">
      <CreditCard className="w-4 h-4 text-[#FFD600] mt-0.5 shrink-0" />
      <div>
        <div className="font-semibold text-slate-100">{included ? "Nothing to pay — included in your membership." : "Nothing to pay today."}</div>
        {!included && <div className="text-slate-400 mt-1">After your session, David emails you a secure card payment link for <strong className="text-slate-200">${member ? memberPrice : price}</strong>{member ? <span className="text-[#FFD600]"> (member price, {member.discount_pct}% off ${price})</span> : ""}. Cancel free up to 24 hours before.</div>}
      </div>
    </div>
  );
}

export function BookingDetails({ form, setForm, price, member, memberPrice }) {
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const included = member?.included;
  return (
    <div className="grid gap-4 sm:grid-cols-2" data-testid="booking-details">
      <label className="block"><div className="dg-eyebrow mb-1 flex items-center gap-2"><User className="w-3 h-3" /> Full name</div>
        <input className="dg-input" value={form.name} onChange={set("name")} data-testid="fld-name" autoComplete="name" /></label>
      <label className="block"><div className="dg-eyebrow mb-1 flex items-center gap-2"><Mail className="w-3 h-3" /> Email</div>
        <input className="dg-input" type="email" value={form.email} onChange={set("email")} data-testid="fld-email" autoComplete="email" /></label>
      {member && (
        <div className="sm:col-span-2 rounded-xl border border-[#FFD600]/40 bg-[#FFD600]/10 p-3 text-sm text-slate-100 flex items-start gap-2" data-testid="booking-member-note">
          <ShieldCheck className="w-4 h-4 text-[#FFD600] mt-0.5 shrink-0" />
          <div>{included ? <><strong>{member.tier_name}</strong> member — this 30-minute session is <strong>included</strong> this month. Nothing to pay.</> : <><strong>{member.tier_name}</strong> member — your {member.discount_pct}% discount is applied automatically.</>}</div>
        </div>
      )}
      <label className="block sm:col-span-2"><div className="dg-eyebrow mb-1 flex items-center gap-2"><Phone className="w-3 h-3" /> Phone (David calls this number)</div>
        <input className="dg-input" type="tel" value={form.phone} onChange={set("phone")} data-testid="fld-phone" autoComplete="tel" /></label>

      <div className="sm:col-span-2">
        <div className="dg-eyebrow mb-2 flex items-center gap-2"><Video className="w-3 h-3" /> How would you like to meet?</div>
        <div className="flex flex-wrap gap-2" data-testid="fld-meeting-method">
          {MEETING_METHODS.map((m) => (
            <button key={m} type="button" onClick={() => setForm({ ...form, meeting_method: m })} data-testid={`method-${m.replace(/[^a-z]+/gi, "-").replace(/-$/, "").toLowerCase()}`}
              className={`rounded-full px-4 py-2 text-sm border transition-colors ${form.meeting_method === m ? "bg-cyan-500 text-slate-900 border-cyan-500" : "bg-slate-900/50 text-slate-200 border-slate-800 hover:border-cyan-400"}`}>{m}</button>
          ))}
        </div>
      </div>

      <label className="block sm:col-span-2"><div className="dg-eyebrow mb-1">What's going on? (optional)</div>
        <textarea className="dg-input" rows={3} value={form.notes} onChange={set("notes")} data-testid="fld-notes" placeholder="Devices involved, brand/model, what's happening, what you've tried…" /></label>

      {!member && <div className="sm:col-span-2">
        <GiftCodeField form={form} setForm={setForm} tierPrice={price} />
      </div>}

      <PaymentNote form={form} member={member} price={price} memberPrice={memberPrice} />
      {!member && <p className="sm:col-span-2 text-xs text-slate-500" data-testid="booking-member-nudge">Members save 10% on every session — <Link to="/membership" className="dg-link">Dr.Gadget Care from $19/mo</Link>.</p>}
    </div>
  );
}
